import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgGlobe = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M14 2.625A11.375 11.375 0 1 0 25.375 14 11.388 11.388 0 0 0 14 2.625ZM23.625 14c0 .888-.122 1.771-.364 2.625h-4.212c.268-1.74.268-3.51 0-5.25h4.212c.242.854.365 1.737.364 2.625Zm-12.469 4.375h5.688A12.592 12.592 0 0 1 14 23.297a12.607 12.607 0 0 1-2.844-4.922Zm-.426-1.75c-.3-1.737-.3-3.513 0-5.25h6.55c.3 1.737.3 3.513 0 5.25h-6.55ZM4.375 14c0-.888.122-1.771.364-2.625h4.212a17.22 17.22 0 0 0 0 5.25H4.74A9.582 9.582 0 0 1 4.375 14Zm12.469-4.375h-5.688A12.59 12.59 0 0 1 14 4.703a12.608 12.608 0 0 1 2.844 4.922Zm5.723 0h-3.896a14.795 14.795 0 0 0-2.439-4.987 9.656 9.656 0 0 1 6.34 4.987h-.005Zm-10.8-4.987A14.795 14.795 0 0 0 9.33 9.625h-3.9a9.657 9.657 0 0 1 6.339-4.987ZM5.429 18.375h3.9a14.795 14.795 0 0 0 2.44 4.988 9.656 9.656 0 0 1-6.34-4.988Zm10.804 4.988a14.795 14.795 0 0 0 2.44-4.988h3.9a9.655 9.655 0 0 1-6.34 4.988Z" />
  </svg>
);
export default SvgGlobe;
